'use strict';

bbw.service.StatsSvc = Class({

    _getDefaultGoalCategory: function() {
        return 'user';
    },

    hit: function(path, search) {
        var pageUri = new Uri('' + path);
        if (angular.isObject(search)) {
            angular.forEach(search, function (value, key) {
                if (key != '_') {
                    pageUri.queryPairs.push([key, value || null]);
                }
            });
        }
        var page = '' + pageUri;
        if (window.ga) {
            ga('set', 'page', page);
            ga('send', {
                hitType: 'pageview',
                title: document.title,
                page: page
            });
        }
        if (window.yam) {
            yam.hit(page, {title: document.title});
        }
    },

    goal: function(action, category) {
        if (!category) {
            category = this._getDefaultGoalCategory();
        }
        if (window.ga) {
            ga('send', {
                hitType: 'event',
                eventCategory: category,
                eventAction: action
            });
        }
        if (window.yam) {
            yam.reachGoal(action);
        }
    }

});